<template>
  <div class="jumbotron no_space dmbs-container">
    <component :is="paginaActual"></component>
  </div>
</template>
<script>
import { globales } from "../components/comunes";
import privacidadES from "@/components/contenido/privacidadES.vue";
import privacidadEN from "@/components/contenido/privacidadEN.vue";
import privacidadEU from "@/components/contenido/privacidadEU.vue";
import privacidadFR from "@/components/contenido/privacidadFR.vue";

export default {
  mixins: [globales],
  components: {
    privacidadES,
    privacidadEN,
    privacidadEU,
    privacidadFR,
  },
  mounted() {
    this.scrollTop();
  },
  watch: {
    $route(to, form) {
      this.scrollTop();
    },
  },
  methods: {
    scrollTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
  },
  computed: {
    paginaActual() {
      const lang = this.$i18n.locale;
      const id = this.$route.params.id;
      const pagina = this.paginas[id];
      if (pagina) {
        return pagina[lang];
      } else {
        console.log("no existe la pagina", id, this.paginas);
        // this.$router.push('/')
      }
    },
  },
  data() {
    return {
      pagina: "privacidadES",
      paginas: {
        privacidad: {
          es: "privacidadES",
          en: "privacidadEN",
          eu: "privacidadEU",
          fr: "privacidadFR",
        },
      },
    };
  },
};
</script>
